import { Extension } from '@tiptap/core';
import { Plugin, PluginKey } from 'prosemirror-state';

// A valid URL that begins with a URL prefix followed by any number of non space character
const BASE_UTF8_URL_TEST_REGEX = '((?:https?)://)[^\\s/$.?#][^\\s]*';
// Check that the entire string is a valid URL
const UTF8_COMPLETE_URL_TEST_REGEX = new RegExp(
  `^${BASE_UTF8_URL_TEST_REGEX}$`,
  'i',
);
const isHttpURL = (url: string): boolean => {
  if (url.indexOf(' ') > -1) {
    return false;
  }
  return UTF8_COMPLETE_URL_TEST_REGEX.test(url);
};

/**
 * Returns a complete URL -- including a 'http' prefix if one didn't already exist
 * @param {string} url
 * @returns {string}
 */
const getCompleteURL = (url: string) => {
  // @NOTE(bemerick) 2015-07-31: *** CRITICAL XSS SECURITY CHECK - DO NOT REMOVE ***
  // 1. Check if the URL is a Valid URL meeting our URL Regex Scheme. If it is valid URL format,
  //    then we trust that this URL is safe to render in the DOM without encodeURI().
  //    We do NOT want to encodeURI() in this case because it would break URLs that are already
  //    encoded (ex: Jira Search query URL) since it would double-encode them.
  // 2. If the URL FAILS our valid URL regex check, we cannot trust that it is safe to render
  //    in the DOM without first running it through encodeURI().
  //    This will successfully catch and prevent XSS such as: "x><img src=x onerror=alert(1);>
  // @see https://jira.inside-box.net/browse/NOTE-4052
  if (!isHttpURL(url)) {
    return `http://${encodeURI(url)}`;
  }

  return url;
};

/**
 * Creates a custom extension that prevents new lines from being added when the maximum character limit has been reached.
 * @param predicate - The function that determines whether a new line should be allowed.
 * @returns The created extension.
 */
/* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
const noNewLine = (predicate: any): Extension =>
  Extension.create({
    name: 'noNewLine',
    addProseMirrorPlugins() {
      return [
        new Plugin({
          key: new PluginKey('eventHandler'),
          props: {
            handleKeyDown: (view, event): boolean => {
              return predicate(view, event);
            },
          },
        }),
      ];
    },
  });

export { isHttpURL, getCompleteURL, noNewLine };
